import styled from 'styled-components'
import { addSeconds, format } from 'date-fns'
import Link from 'next/link'
import { usePaymentStatus } from 'querys/payment'
import { Play, Padlock } from 'icons'

const LessonsStyled = styled.div`
  .count-spacer {
    height: 44px;
  }
  @media(min-width: 1024px) {
    .count-spacer {
      display: none;
    }
  }
`

const ModuleStyled = styled.nav`
  margin: 16px 0;
  .lessons {
    border-radius: 4px;
    overflow: hidden;
  }
  .chapter-head {
    display: flex;
    justify-content: space-between;
    padding: 1rem .5rem;
    color: var(--baseNeutral);
    &-title {
      font-size: 16px;
      line-height: 24px;
    }
    &-lessons {
      min-width: 70px;
      text-align: end;
    }
  }
`

const LessonStyled = styled.li`
  cursor: pointer;
  background: var(--neutral100);
  border-bottom: 1px solid var(--white);
  color: var(--baseNeutral);
  &:hover {
    background: var(--neutral90);
  }
  &:last-of-type {
    border-bottom: none;
  }
  a {
    display: flex;
    padding: 16px;
    align-items: center;
    justify-content: space-between;
  }
  .lesson-name {
    font-size: 16px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    -webkit-box-orient: vertical;
  }
  img {
    margin-right: 8px;
  }
  .lesson-title-container {
    display: flex;
    justify-content: space-between;

    p {
      margin-inline-start: 8px;
      flex: 1;
    }
  }
  .lesson-title {
    display: flex;
    align-items: center;
  }
  .free-lesson {
    flex-shrink: 0;
    height: fit-content;
    border: 1px solid #ff0071;
    background: #ff0071;
    color: white;
    border-radius: .5em;
    padding: .3em;
    display: inline-block;
    margin-left: 8px;
    font-size: 0.7em;
    line-height: 0.7em;
  }
  .lesson-duration {
    justify-self: flex-end;
    margin-left: 8px;
  }
`

function Module({
  title, lessons, idx, course, free,
}) {
  const { data: { has_access: paymentStatus } } = usePaymentStatus(course)
  return (
    <ModuleStyled role="navigation" aria-labelledby={`chapter-${idx}`}>
      <div className="chapter-head">
        <h3 className="chapter-head-title" id={`chapter-${idx}`}>
          {idx}
          {'. '}
          {title}
        </h3>
        <span className="chapter-head-lessons">{`${lessons.length} ${lessons.length === 1 ? 'clase' : 'clases'}`}</span>
      </div>
      <ul className="lessons">
        {lessons.map(({
          title: lessonTitle, total_duration, has_access, slug,
        }) => (
          <LessonStyled key={slug}>
            <Link href={`/aprender/${course}/${slug}`} id={slug}>
              <div className="lesson-title-container">
                {has_access || free ? (
                  <Play color="var(--turquoise)" width="21px" height="20px" />
                ) : (
                  <Padlock color="var(--baseNeutral)" width="21px" height="20px" />
                )}
                <p className="lesson-title">
                  <span className="lesson-name">{lessonTitle}</span>
                  {
                      (has_access && !paymentStatus) && (
                        <small className="free-lesson">Ver clase</small>
                      )
                    }
                </p>
              </div>
              <span className="lesson-duration">
                {format(addSeconds(new Date(0), total_duration), 'mm:ss')}
              </span>
            </Link>
          </LessonStyled>
        ))}
      </ul>
    </ModuleStyled>
  )
}

function Lessons({
  chapters, course, free,
}) {
  return (
    <LessonsStyled>
      {chapters?.map(({ uuid, title, lessons }, idx) => (
        <Module
          key={uuid}
          course={course}
          idx={idx + 1}
          title={title}
          free={free}
          lessons={lessons}
        />
      ))}
    </LessonsStyled>
  )
}

export default Lessons
